import React, { useEffect } from 'react';

import { useSnackbar } from 'notistack';
import { BaseSnackbar } from 'src/components';
import { fakeNotistackMessage } from 'src/helpers';
import { popNotification, useSelectNotifications } from 'src/notifications';
import { v4 as uuid4 } from 'uuid';

export function useNotifier(): void {
  const { enqueueSnackbar } = useSnackbar();
  const notifications = useSelectNotifications();

  useEffect(() => {
    if (notifications.length) {
      const [{ action, children, dataCy, key, message = '', variant, ...restOptions }] =
        notifications;
      const id = key ?? uuid4();

      popNotification();
      enqueueSnackbar(fakeNotistackMessage, {
        content: (
          <BaseSnackbar action={action} dataCy={dataCy} id={id} message={message} variant={variant}>
            {children}
          </BaseSnackbar>
        ),
        key: id,
        ...restOptions,
      });
    }
  }, [notifications, enqueueSnackbar]);
}
